module.exports = __webpack_public_path__ + "img/monza-logo-icon.8459d6a9.png";